/** Bảng cài đặt M3: hiệu ứng + tiếp cận (3.5) + âm thanh + bản lưu. */
import { useState } from 'preact/hooks';
import type { GameController } from '../game-controller.js';
import { styleNutPhu, stylePanel, useCapNhat } from '../dung-chung.js';

export function CaiDat(props: { controller: GameController }) {
  const { controller } = props;
  const [xacNhanXoa, setXacNhanXoa] = useState(false);
  const [chuoiNhap, setChuoiNhap] = useState('');
  const [chuoiXuat, setChuoiXuat] = useState('');
  useCapNhat(controller);
  const cd = controller.caiDat;

  const muc = (nhan: string, moTa: string, bat: boolean, doi: (v: boolean) => void) => (
    <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', cursor: 'pointer' }}>
      <input
        type="checkbox"
        checked={bat}
        onChange={(e) => doi((e.target as HTMLInputElement).checked)}
      />{' '}
      {nhan}
      <div style={{ fontSize: '12px', opacity: 0.75 }}>{moTa}</div>
    </label>
  );

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>⚙️ Cài đặt</h3>
      {muc('Hiệu ứng bloom', 'Ánh sáng dịu kiểu HD-2D', cd.bloom, (v) =>
        controller.datCaiDat({ bloom: v }),
      )}
      {muc(
        'Độ phân giải đầy đủ',
        'Tắt để render 1/2 (mặc định, mượt hơn)',
        cd.doPhanGiaiDayDu,
        (v) => controller.datCaiDat({ doPhanGiaiDayDu: v }),
      )}
      {muc('Giảm chuyển động', 'Tắt bloom và hiệu ứng chuyển động mạnh', cd.giamChuyenDong, (v) =>
        controller.datCaiDat({ giamChuyenDong: v }),
      )}

      <h4 style={{ margin: '12px 0 6px', fontSize: '14px' }}>Tiếp cận</h4>
      {muc('Cỡ chữ lớn', 'Chữ to hơn cho dễ đọc', cd.coChuLon, (v) =>
        controller.datCaiDat({ coChuLon: v }),
      )}
      {muc('Tắt rung', 'Không rung khi có sự kiện', cd.tatRung, (v) =>
        controller.datCaiDat({ tatRung: v }),
      )}
      {muc('Tắt hiệu ứng', 'Tắt hiệu ứng hạt/thời tiết', cd.tatHieuUng, (v) =>
        controller.datCaiDat({ tatHieuUng: v }),
      )}

      <h4 style={{ margin: '12px 0 6px', fontSize: '14px' }}>Âm thanh</h4>
      {muc('Nhạc nền', 'Tắt/mở nhạc (placeholder sinh bằng code)', cd.nhacBat, (v) =>
        controller.datCaiDat({ nhacBat: v }),
      )}
      {muc('Hiệu ứng âm thanh', 'Tắt/mở tiếng bíp sự kiện', cd.sfxBat, (v) =>
        controller.datCaiDat({ sfxBat: v }),
      )}

      <h4 style={{ margin: '12px 0 6px', fontSize: '14px' }}>Bản lưu</h4>
      <p style={{ fontSize: '12px', opacity: 0.8, margin: '0 0 6px' }}>
        Tự lưu mỗi 30 giây và khi thoát. Xuất/nhập bằng chuỗi JSON.
      </p>
      <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
        <button onClick={() => setChuoiXuat(controller.xuatLuu())} style={styleNutPhu}>
          Xuất
        </button>
        <button
          onClick={() => {
            try {
              controller.nhapLuu(chuoiNhap);
              setChuoiNhap('');
              alert('Nhập bản lưu thành công.');
            } catch (e) {
              alert(`Nhập thất bại: ${e instanceof Error ? e.message : e}`);
            }
          }}
          style={styleNutPhu}
        >
          Nhập
        </button>
        {!xacNhanXoa ? (
          <button onClick={() => setXacNhanXoa(true)} style={styleNutPhu}>
            Xóa tiến trình
          </button>
        ) : (
          <>
            <button
              onClick={() => {
                controller.xoaLuu();
                location.reload();
              }}
              style={{
                background: '#a33',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 14px',
                cursor: 'pointer',
              }}
            >
              Chắc chắn xóa?
            </button>
            <button onClick={() => setXacNhanXoa(false)} style={styleNutPhu}>
              Hủy
            </button>
          </>
        )}
      </div>
      {chuoiXuat && (
        <textarea
          readOnly
          value={chuoiXuat}
          rows={4}
          style={{ width: '100%', fontSize: '11px', marginBottom: '6px' }}
          onFocus={(e) => (e.target as HTMLTextAreaElement).select()}
        />
      )}
      <textarea
        value={chuoiNhap}
        onInput={(e) => setChuoiNhap((e.target as HTMLTextAreaElement).value)}
        placeholder="Dán chuỗi JSON đã xuất để nhập…"
        rows={3}
        style={{ width: '100%', fontSize: '11px' }}
      />
    </div>
  );
}
